<home-screen data-crlat="homeScreen"></home-screen>

<ng-container *ngIf="!isProduction">
    <lazy-component moduleUri="@lazy-modules-module/devLog/dev-log.module#DevLogModule"></lazy-component>
</ng-container>

<banners-section *ngIf="isHomePage" [page]="'homepage'" class="vn-bma home-banner"></banners-section>
<bma-main class="vn-bma"></bma-main>
